import {addModule, getModule} from "..//Utility/ModuleUtility";
import {ItemsEnv} from "../Modules/ICAM/Items";
import {movimentazioniEnv} from "../Modules/ICAM/movimentazioni";
import {correzioniEnv} from "../Modules/ICAM/correzioni";
 const gmaenvironment = {
  apiUrl: 'https://www.giemmea.eu/api',
  Wp: false,
  hasCustomizer:true,
  IDTecnico: "RT",
  IDCliente: "C",
  IDAdmin: "AZ",
  IDRoot: "SA",
  ClientiType: ['CA', 'C', 'AC'],
  filtrife: [
    {id: "T", label: "Tutti", capacita: [], module: undefined},
    {id: "R", label: "Interventi", capacita: [], module: "Rma", SubFilter: [
        {id: "RA", label: "Richieste di assistenza", capacita: [], module: undefined, fieldnotexist: ['padre']},
        {id: "I", label: "Interventi", capacita: [], module: undefined, fieldexist: 'padre'},
      ]},
    // {id: "A", label: "Attivita", capacita: [], module: undefined},
    {id: "C", label: "CRM", capacita: [], module: undefined},
    {id: "W", label: "Attivita", capacita: [], module: undefined},
  ],
  legenda: [{
    area: "Legenda",
    list: true,
    legenda: [
      {label: "Inserita/o", color: "#ff0000"},
      {label: "In Lavorazione", color: "#ffd000"},
      {label: "Chiuso", color: "#239d00"},
    ]
  }],
  production: true,
  bbbUrl: 'https://newsbs.ddns.net/bigbluebutton',
  langPrefix: './assets/i18n/',
  langSuffix: '_Giemmea.json',
  ClientebaseUrl: '/Cliente/formazienda/c/',
  baseUrl: '/task/calendario',
  href: '/Login',
  homepages: [
  ],
  //#region Layout Config
  logoPath: 'assets/images/logo_giemmea.png',
  loginMsg: '',
  loginbgPath: '#58585a',
  icon:'',
  logoBg: 'skin1', // six possible values: skin(1/2/3/4/5/6),
  AuthWrapperBg: '#58585a', // six possible values: skin(1/2/3/4/5/6),
  navbarbg: 'skin1', // six possible values: skin(1/2/3/4/5/6)
  sidebarbg: 'skin1', // six possible values: skin(1/2/3/4/5/6)
  userCircleColor: "",
  theme: 'light',
  dir: 'ltr', // two possible values: ltr, rtl
  layout: 'vertical', // fixed value. shouldn't be changed.
  sidebartype: 'full', // four possible values: full, iconbar, overlay, mini-sidebar
  sidebarpos: 'fixed', // two possible values: fixed, absolute
  headerpos: 'fixed', // two possible values: fixed, absolute
  boxed: 'full', // two possible values: full, boxed
  //#endregion
  //#region Moduli
  Modules:{
    "twoFactorAuth": false,
    "Admin": true,
    "Personale": true,
    "Clienti": true,
    "Interventi": false,
    "Prima_Nota": false,
    "Materiali": true,
    "Listini": false,
    "Progetti": true,
    "Prodotti": true,
    "Documenti": false,
    "Scadenzario": false,
    "Spedizioni": false,
    "Stampe": true,
    "Task": true,
    "Shared": false,
    "Dashboard": true,
    "Settings": true,
    "Formazione": false,
    "VersioneCarbotti": false,
    "PartiProdotto": false,
    "Parti": false,
    "Rma": true,
    "Ecommerce": false,
    "ScadenzeFiglie": false,
    "Registrazione": false,
    "Ticket": true,
    "Acquisti": false,
    "taskboard": false,
    "Camera":false,
    "Valutazioni":false
  },
//#endregion
  //#region Addon
  Personale: {
    Corsi: true,
    RuoliOperativi:false,
  },
  PartiAddOn: [false], // categorie associate
  ClientiAddOn: {
    RuoloDefault: {id: "C", label: "Cliente"},
    enable: true,
    info: true,
    commerciale: false,
    segnalatore: false,
    segnalatoreInterno: false,
    sedi: true,
    TipoSedePrimaria: false,
    attivita: true,
    regione: true,
    geolocalizzazione: false,
    ruolo: true,
    Modifica: false,
    prodotti: true,
    rma: true,
    codAdhoc: false,
    accesso: false,
    referenti: false,
    interventi: false,
    note_private: false,// rende invisibile il campo note al cliente
    rating: false,
    ruoliAccesso: false,
    compilazione: false,
    luogoNascita: false,
    dataNascita: false,
    statoCivile:false,
    titoloStudio: false,
    occupazione: false,
    invalidita: false,
    legge104: false,
    diagnosi: false,
    accompagnamento:false,
    pensione: false,
    tutelare: false,
    medico: false,
    telMedico: false,
    terapia: false,
    checkAmm: true,
    RmaSede:true,
    ProveAcquistoSede: true,
    CampiSede:[
      {
        modificabile:true,
        nome: 'Tipo',
        oggetti: ['tipiSede'],
        inputType: 'singleDropdown',
        source: 'tipologieSedi',
        internalOutput: 'tipiObject',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput:false,
          idField: 'id',
          textField: 'label',
        },
        titleClass: 'control-label col-form-label'  ,
        class: 'col-lg-5',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Alias:',
        oggetti: ['alias'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-7',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Indirizzo:',
        oggetti: ['indirizzo'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Cap:',
        oggetti: ['cap'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-2',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Città:',
        oggetti: ['citta'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Provincia:',
        oggetti: ['provincia'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-1',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Regione:',
        oggetti: ['regione'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Email ( email multiple separate da ";" ):',
        oggetti: ['email'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-6',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Telefono ( numeri multipli separati da ";" ):',
        oggetti: ['telefono'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-6',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Note:',
        oggetti: ['note'],
        inputType: 'textarea',
        titleClass: 'control-label col-form-label',
        class: 'col-12',
        visibleifProhibited: true
      },
    ],
    FiltriSede: [
      {
        modificabile: true,
        nome: 'Alias:',
        oggetti: ['alias'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Indirizzo:',
        oggetti: ['indirizzo'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Cap:',
        oggetti: ['cap'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-2',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Città:',
        oggetti: ['citta'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Provincia:',
        oggetti: ['provincia'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-1',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Regione:',
        oggetti: ['regione'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Email :',
        oggetti: ['email'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Telefono:',
        oggetti: ['telefono'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true
      }
    ]
  },
  ProdottiAddOn: {
    shortDescription: true,
    classeEnergetica: true,
    tags: true,
    video: true,
    dettaglio:true,
    updated_at:true,
    files: true,
    cart: true,
    codice: true,
    codice_produttore: false,
    tipo: true,
    standby: true,
    tipi:true, // tipi di prodotto (1 - 2ante klima)
    cat_image: true,
    lista_prezzo: false,
    TranslatedDesc: true,
    import:true,
    codAdhoc:true,
    DragSort: true,
    cat_Sort: true,
    sottoTitolo: true,
    rifornimento:true,
    prodottiCorrelati: true,
    CampiAggiuntivi: [
      {nome:'prodotti.pesoVolume', oggetti:['pesoVolume'], modificabile: true, inputType: 'number', class: 'col-lg-3'},
    ],
    prodottiFilter: [
      {nome: "Cerca", oggetti: ['pdv'], type: "text", filtertype: '69',  class: 'col-lg-9' },
    ],
    ProdottiListHeader:[
      {nome: "Nome", oggetti: ["prodotto"],type: 'text', filtertype: '69' },
      {nome: "Stock", oggetti: ["magazzino"],type: 'text', filtertype: '69' },
      {nome: "Prodotto", oggetti: ["prodotto"],type: 'text', filtertype: '68' },
      {nome: "Quantita da incrementare", oggetti: ["qta"],type: 'text', filtertype: '69', modificabile: true },

      /*{nome: "Tipologia", oggetti: ['type'], type: 'replace', replacement: [{original: 'C', replace:'CRM'}, {original: 'S', replace:'Scadenza'}, {original: 'R', replace:'Attività'},{original: 'W', replace:'Visita'}]},*/
    ],
    AzioniLista:[
      {nome: '', parameterInArray: true,  class:'link font-16 text-orange font-medium mr-2', filtertype: '69', type: 'POST', restRoute: '/prodotti/magazzini/movimentazioni/add',  icon:'fas fa-plus', successMex: "Carico Effettuato con successo", parameter: [{nome:"prodotto_id", parameter: 'id'}, {nome:'mag_ingresso_id', value: 2}, {nome:'qta', parameter:'qta'}]},
    ],
    SezioniCodiciSconto: [
      {
        sezione:'',
        campi:[
          {
            oggetti: ['prodotto'],
            modificabile: true,
            nome: 'Accessorio',
            inputType: 'text',
            titleClass: 'control-label col-form-label',
            class: 'col-md-3',
            visibleifProhibited: true
          },
          {
            oggetti: ['tags'],
            modificabile: true,
            nome: 'Alias',
            inputType: 'text',
            titleClass: 'control-label col-form-label',
            class: 'col-md-3',
            visibleifProhibited: true
          },
          {
            oggetti: ['codice'],
            modificabile: true,
            nome: 'Codice Articolo',
            inputType: 'text',
            titleClass: 'control-label col-form-label',
            class: 'col-md-3',
            visibleifProhibited: true
          },
          {
            oggetti: ['codice_produttore'],
            modificabile: true,
            nome: 'Codice Fornitore',
            inputType: 'text',
            titleClass: 'control-label col-form-label',
            class: 'col-md-3',
            visibleifProhibited: true
          },

          {
            oggetti: ['codiceAdhoc'],
            modificabile: true,
            nome: 'Codice a barre',
            inputType: 'text',
            titleClass: 'control-label col-form-label',
            class: 'col-md-3',
            visibleifProhibited: true
          },

          {
            oggetti: ['marca'],
            modificabile: true,
            nome: 'Produttore',
            inputType: 'text',
            titleClass: 'control-label col-form-label',
            class: 'col-md-3',
            visibleifProhibited: true
          },
          {
            oggetti: ['magazzino'],
            modificabile: false,
            nome: 'Stock',
            inputType: 'text',
            titleClass: 'control-label col-form-label',
            class: 'col-md-3',
            visibleifProhibited: true
          },
          {
            oggetti: ['sottoTitolo'],
            modificabile: true,
            nome: 'Note',
            inputType: 'textarea',
            titleClass: 'control-label col-form-label',
            class: 'col-md-12',
            visibleifProhibited: true
          },

          {
            source: "/prodotti/magazzini/movimentazioni/list",
            parameter: [{nome:"page", value: 0}, {nome:"size", value: 200}, {nome: "prodotto_id", parameter: "id" }],
            nome: 'Movimentazioni',
            oggetti: ['movimentazioni'],
            type:"table",
            hideif:{ fieldnotexist:'id'},
            header:[
              {nome: "Magazzino Ingresso", oggetti: ['mag_ingresso'], style:{'margin-left':'10px'},},
              {nome: "Magazzino Uscita", oggetti: ['mag_uscita'], style:{'margin-left':'10px'},},
              {nome: "Data", oggetti: ['created_at'],  inputType: 'datetime-local',style:{'margin-left':'10px'},},
              {nome: "Descrizione", oggetti: ['descrizione'], style:{'margin-left':'10px'},},
              {nome: "Quantita", oggetti: ['qta'], style:{'margin-left':'10px'},},
            ],
            responseHasData: true,
            modificabile: true,
            class: 'col-lg-12',
          },
          {
            type:'image',
            oggetti:['id_immagine'],
            imageToServer: 'immagine',
            filename: 'file',
            titleClass: 'control-label col-form-label',
            class: 'col-md-3',
            visibleifProhibited: true,
            modificabile: true
          },
          {
            modificabile:true,
            nome: 'Categoria',
            oggetti: ['categorie'],
            inputType: 'singleDropdown',
            source: '/prodotti/accessori/cat/list/list',
            parameter: [{nome:"page", value: 1}, {nome:"size", value: 200}],
            internalOutput: 'categorieObject',
            placeholder: 'Seleziona',
            OutputField: 'categorie',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: false,
              idField: 'id',
              textField: 'categoria',
              allowSearchFilter: true,
            },
            titleClass: 'control-label col-form-label'  ,
            class: 'col-lg-3',
            visibleifProhibited: true
          },
        ],
      }
    ],
  },
  CalendarAddon: {
    managerScadenza : false,
  },
  TaskAddon: {
    checkList : false,
    sidebarFilter: [
      {
        nome: 'Cliente',
        source: '/anagrafica/clienti/list',
        parameter: [{nome:"page", value: 1}, {nome:"size", value: 2000}],
        responseHasData: true,
        oggetti: ['cliente'],
        internalOutput: 'clienteObject',
        OutputField: 'cliente',
        OnChange: 'OnClienteChange',
        modificabile: true,
        inputType: 'singleDropdown',
        hideif: {fieldexist: 'hideCliente'},
        placeholder: 'Seleziona un Cliente',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'nominativo',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: false,
        },
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        nome: 'Responsabile',
        source: '/anagrafica/persone/list',
        parameter: [{nome:"page", value: 1}, {nome:"size", value: 200}],
        responseHasData: true,
        oggetti: ['manager'],
        internalOutput: 'managerObject',
        OutputField: 'persona',
        OnChange: 'OnManagerChange',
        OnFilter: 'filtroManager',
        modificabile: true,
        inputType: 'singleDropdown',
        placeholder: 'Seleziona un Responsabile',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'fullName',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: true,
        },
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Categoria Operativa',
        oggetti: ['categoria'],
        inputType: 'singleDropdown',
        source: '/rma/rma/categorie',
        parameter: [],
        internalOutput: 'catOperativaObject',
        OutputField: 'categoria',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput:true,
          idField: 'id',
          textField: 'label',
        },
        titleClass: 'control-label col-form-label'  ,
        class: 'col-lg-12',
        visibleifProhibited: true,
      },
      {
        modificabile: true,
        nome: 'Assegnabile',
        oggetti: ['assegnabile'],
        inputType: 'singleDropdown',
        source: [{id:true, label: 'si'},{id:false,label: 'no'},{id:null,label: 'NA'}],
        internalOutput: 'assegnabileObject',
        OutputField: 'assegnabile',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput:true,
          idField: 'id',
          textField: 'label',
        },
        titleClass: 'control-label col-form-label'  ,
        class: 'col-lg-12',
        visibleifProhibited: true,
      },
      {
        modificabile: true,
        nome: 'Data appuntamento',
        oggetti: ['dataAppuntamento'],
        inputType: 'singleDropdown',
        source: [{id:true,label: 'si'},{id:false,label: 'no'},{id:null,label: 'NA'}],
        internalOutput: 'dataAppuntamentoObject',
        OutputField: 'dataAppuntamento',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput:true,
          idField: 'id',
          textField: 'label',
        },
        titleClass: 'control-label col-form-label'  ,
        class: 'col-lg-12',
        visibleifProhibited: true,
      },
      {
        modificabile: true,
        nome: 'Allegati',
        oggetti: ['allegati'],
        inputType: 'singleDropdown',
        source: [{id:true,label: 'si'},{id:false,label: 'no'},{id:null,label: 'NA'}],
        internalOutput: 'allegatiObject',
        OutputField: 'allegati',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput:true,
          idField: 'id',
          textField: 'label',
        },
        titleClass: 'control-label col-form-label'  ,
        class: 'col-lg-12',
        visibleifProhibited: true,
      },
      {
        modificabile: true,
        nome: 'Task Status',
        oggetti: ['taskStatus'],
        inputType: 'singleDropdown',
        source: [{id:true,label: 'si'},{id:false,label: 'no'},{id:null,label: 'NA'}],
        internalOutput: 'taskStatusObject',
        OutputField: 'taskStatus',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput:true,
          idField: 'id',
          textField: 'label',
        },
        titleClass: 'control-label col-form-label'  ,
        class: 'col-lg-12',
        visibleifProhibited: true,
      },
      {
        modificabile: true,
        nome: 'InterventoStatus',
        oggetti: ['chiuso'],
        inputType: 'singleDropdown',
        source: [{id:true,label: 'chiuso'},{id:false,label: 'aperto'},{id:null,label: 'NA'}],
        internalOutput: 'chiusoObject',
        OutputField: 'chiuso',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput:true,
          idField: 'id',
          textField: 'label',
        },
        titleClass: 'control-label col-form-label'  ,
        class: 'col-lg-12',
        visibleifProhibited: true,
      },
      {
        modificabile: true,
        nome: 'Tipo Apprestamento',
        oggetti: ['prodotto'],
        inputType: 'singleDropdown',
        source: '/prodotti/list',
        parameter: [{nome:"page", value: 0}, {nome:"size", value: 200},{nome:"tipo", value:68}],
        responseHasData: true,
        internalOutput: 'prodottoObject',
        OutputField: 'prodotto',
        placeholder: 'Seleziona un prodotto',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'prodotto',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: false,
        },
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Indirizzo',
        oggetti: ['indirizzo'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'paese',
        oggetti: ['citta'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'provincia',
        oggetti: ['provincia'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'regione',
        oggetti: ['regione'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Tipo Richiesta',
        oggetti: ['tipoIntervento'],
        inputType: 'singleDropdown',
        source: '/rma/rma/types',
        internalOutput: 'tipoObject',
        OutputField: 'tipoIntervento',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput:true,
          idField: 'id',
          textField: 'label',
        },
        titleClass: 'control-label col-form-label'  ,
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Data segnalazione',
        oggetti: ['dataSegnalazione'],
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Data Scadenza',
        oggetti: ['dataScadenza'],
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'codice richiesta',
        oggetti: ['codice'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Codice Richiesta giemmea',
        oggetti: ['id'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Codice Chiusura',
        oggetti: ['codiceChiusura'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-12',
        visibleifProhibited: true
      },
    ],
    ListTableHeaderField:[
      {nome: "Titolo", oggetti: ['type', 'nome'], type: 'replace', replacement: [{original: 'R', fieldexist: 'padre', replace:'Intervento #'},{original: 'R', fieldnotexist: 'padre', replace:'Richiesta #'},{original: 'W', replace:'Attività'},{original: 'C', replace:'CRM'}], color:[{colore: '#ff0000', fieldexist:'id'}, {colore: '#ffd000', fieldexist:'managerObject'},{colore: '#239d00', fieldexist:'chiuso'}] },
      {nome: "Richiesta", oggetti: ['padre'], filtertype: 'I'},
      {nome: "Codice", oggetti: ['id'],filtertype: 'RA'},
      {nome: "Luogo di Intervento", oggetti: ['sedeObject'], type: "object", field:['fullAddress']},
      {nome: "Cliente", oggetti: ['acquirente'], type: "object", field:['nominativo']},
      {nome: "Tipologia", oggetti: ['type'], type: 'replace', replacement: [{original: 'R', fieldexist: 'padre', replace:'Intervento'},{original: 'R', fieldnotexist: 'padre', replace:'Richiesta'}]},
      {nome: "Responsabile", oggetti: ['managerObject'],field:["fullName"], type: "object"},
      {nome: "Data Segnalazione / Programmata entro", oggetti: ['data_inizio_prevista'], inputType: "date"},
    ],
    calendarHeaderField: [
      {nome: "Titolo", oggetti: ['type', 'id', 'nome'], type: 'replace', replacement: [{original: 'R', fieldexist: 'padre', replace:'Intervento #'},{original: 'R', fieldnotexist: 'padre', replace:'Richiesta #'},{original: 'W', replace:'Attività'},] },
      {nome: "Luogo di Intervento", oggetti: ['sedeObject'], type: "object", field:['fullAddress']},
    ],
    ColoriCalendario:[
      {colore: '#ff0000', fieldexist:'id', fieldnotexist: undefined, arrayEmpty: undefined, arrayFull: undefined},
      {colore: '#ffd000', fieldexist:'managerObject', fieldnotexist: undefined, arrayEmpty: undefined, arrayFull: undefined},
      {colore: '#239d00', fieldexist:'chiuso', fieldnotexist: undefined, arrayEmpty: undefined, arrayFull: undefined}
    ]
  },
  ProgettiAddon: {
    commerciale: false,
    segnalatore: false,
    categoriaVoceDiCosto: false,
    lavorato: false,
    OggettoNascosto: false,
    HideColore: false,
    banche: false,
    HidePrezzo: false,
    gestore: true,
    costoSpedizione: false,
    destinazioni:false,
    pagato: false,
    CampiAggiuntivi: [ // campi aggiuntiv voci di costo
    ],
    CampiAggiuntiviLista: [
      // {nome:'Offerta.Conferma', oggetti:['data_conferma'], type: 'date'},
    ],
    filters: [
      {nome:'Offerta.Codice', oggetti:['codice'], modificabile:true, inputType: 'text', class: 'col-lg-9'},
    ],
    Revisioni: false,
    tipoPagamento: false,
    francoDeposito:false,
    CampiOfferta: [
      {
        modificabile:true,
        nome: 'Offerta.Responsabile',
        oggetti: ['manager'],
        inputType: 'singleDropdown',
        source: 'managers',
        internalOutput: 'managerObject',
        OnFilter: 'filtroManager',
        OnChange: 'OnManagerChange',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput:true,
          idField: 'id',
          textField: 'fullName',
          searchPlaceholderText: "inserire almeno 3 caratteri",
          allowSearchFilter: true,
          allowRemoteDataSearch: true,
        },
        titleClass: 'control-label col-form-label'  ,
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile:true,
        nome: 'Gestore',
        oggetti: ['manager'],
        inputType: 'singleDropdown',
        source: 'managers',
        internalOutput: 'gestoreObject',
        OnFilter: 'filtroCommerciale',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput:true,
          idField: 'id',
          textField: 'fullName',
          searchPlaceholderText: "inserire almeno 3 caratteri",
          allowSearchFilter: true,
          allowRemoteDataSearch: true,
        },
        titleClass: 'control-label col-form-label'  ,
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Numero Ordine:',
        oggetti: ['codice'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-2',
        placeholder: 'Numero Ordine:',
        visibleifProhibited: true
      },
      {
        prevDivClass: "col-md-12",
        modificabile: true,
        nome: 'Offerta.Creazione',
        oggetti: ['data_creazione'],
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Offerta.Offerta',
        oggetti: ['data_emissione'],
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Offerta.Accettazione',
        oggetti: ['data_accettazione'],
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Offerta.Conferma',
        oggetti: ['data_conferma'],
        inputType: 'date',
        titleClass: 'control-label col-form-label',
        class: 'col-md-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Note',
        oggetti: ['note'],
        inputType: 'textarea',
        titleClass: 'control-label col-form-label',
        class: 'col-md-6',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Note Private',
        oggetti: ['note_private'],
        inputType: 'textarea',
        titleClass: 'control-label col-form-label',
        class: 'col-md-6',
        visibleifProhibited: false
      },
    ],
    CampiSottoOfferta: [
    ]
  },
  RmaAddOn: {
    fieldProgressivo: 'codice',
    taskGenerico: false,
    vociDiCosto: false,
    provaAcquisto: true,
    CategoriaProdotto: true,
    TipoAcquisto: false,
    TipoAcquistoSource: "ClientiType",
    Rivenditore: false,
    NumeroDocumento: false,
    DataDocumento: false,
    Ricevuta: false,
    Targhetta: false,
    CircostanzaDifetto: false,
    DescrizioneDifetto: false,
    AddinCalendar: true,
    Difetto: true,
    Telefono: true,
    Garanzia: true,
    EstensioneGaranzia: true,
    Allegati: true,
    Modello: true,
    Matricola: true,
    Brand: true,
    sottoTask: true,
    ProveAcquistoMultipleRma: true,
    InterventiFigli:true,
    useTasklistInClienti: true,
    Ritiro: {
      Enabled: false,
      Referente: true,
      Nominativo: true,
      Indirizzo: true,
      Citta: true,
      Cap: true,
      Provincia: true,
      Telefono: true,
      Email: true,
      Chiusura: true,
      Disponibilita: true
    },
    Cliente: {
      Enabled: false,
      Referente: false,
      Nominativo: false,
      Indirizzo: true,
      Citta: true,
      Cap: true,
      Provincia: true,
      Telefono: false,
      Email: false,
      Chiusura: false,
      Disponibilita: false
    },
    Assistenza: {
      Enabled: false,
      Referente: true,
      Nominativo: true,
      Indirizzo: true,
      Citta: true,
      Cap: true,
      Provincia: true,
      Telefono: true,
      Email: true,
      Chiusura: true,
      Disponibilita: true,
      Tecnico: false,
    },
    ListProvaAcquistoRmaField:[
      {nome: "Posizione", oggetti: ['posizione']},
      {nome: "Apprestamento", oggetti: ['prodotto']},
      {nome: "Marca", oggetti: ['marca']},
      {nome: "Ubicazione", oggetti: ['ubicazione']},
      {nome: "Note", oggetti: ['note']},
    ],
    CampiProvaAcquisto: [
      {
        modificabile: true,
        nome: 'Sede',
        oggetti: ['sedeId'],
        disabledif: {fieldexist: 'id'},
        inputType: 'singleDropdown',
        source: 'SediSource',
        internalOutput: 'sedeObject',
        OnFilter: 'filtroSede',
        OnChange: 'OnSedeChange',
        OutputField: 'sedeId',
        viewInList: true,
        placeholder: 'Seleziona una sede',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'fullAddress',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: false,
        },
        class: 'col-lg-4',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'N° Posizione',
        oggetti: ['posizione'],
        inputType: 'text',
        viewInList: true,
        titleClass: 'control-label col-form-label',
        class: 'col-lg-4',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'N° QrCode',
        oggetti: ['qrcode'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-4',
        visibleifProhibited: true
      },

      {
        modificabile: true,
        nome: 'Tipo Apprestamento',
        oggetti: ['id_prodotto'],
        inputType: 'singleDropdown',
        source: '/prodotti/list',
        parameter: [{nome: "page", value: 0}, {nome: "size", value: 200},{nome:"tipo", value: 68}],
        responseHasData: true,
        internalOutput: 'prodottoObject',
        OutputField: 'id_prodotto',
        placeholder: 'Seleziona un prodotto',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'prodotto',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: false,
        },
        class: 'col-lg-4',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Modello',
        oggetti: ['prodotto'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-4',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Marca',
        oggetti: ['marca'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-4',
        visibleifProhibited: true
      },
      {
        nome: 'Sistema di comando',
        source: '/settings/get',
        parameter: [{nome:"id", value: 'comando'},{nome:"type", value: 'comando'}],
        responseHasData: false,
        oggetti: ['comando'],
        internalOutput: 'comandoObject',
        OutputField: 'comando',
        modificabile: true,
        inputType: 'singleDropdown',
        placeholder: 'Sistema di comando',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'label',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: true,
        },
        class: 'col-lg-4',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Ante',
        oggetti: ['ante'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-4',
        visibleifProhibited: true
      },
      //qrcode, prodotto, marca, anno,ante,posizione , dismesso
      {
        modificabile: true,
        nome: 'Matricola',
        oggetti: ['seriale'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-4',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Anno',
        oggetti: ['anno'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-4',
        visibleifProhibited: true
      },
      {nome:'Data Installazione:', oggetti: ['dataDoc'],  inputType: 'date', modificabile: true, class: 'col-lg-4'},
      {
        modificabile: true,
        nome: 'Dismesso:',
        oggetti: ['dismessochk'],
        inputType: 'checkbox',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-1',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Dismesso il :',
        oggetti: ['dismesso'],
        inputType: 'date',
        disabledif: {fieldnotexist: 'dismessochk'},
        titleClass: 'control-label col-form-label',
        class: 'col-lg-2',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Ubicazione',
        oggetti: ['ubicazione'],
        viewInList: true,
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Note',
        oggetti: ['note'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {nome: "Files", type: "Files", url:"/rma/register/file", class: 'col-lg-12', OnChange: 'OnFilesChange', GestioneFile: true, modificabile: true}
    ],
    CampiRmaAdd: [
      {
        sezione: '',
        campi:[
          {
            nome: 'Cliente',
            source: "AziendeSource",
            oggetti: ['cliente_id'],
            disabledif: {fieldexist: 'sedeObject'},
            internalOutput: 'clienteObject',
            OutputField: 'cliente_id',
            OnChange: 'OnClienteChange',
            modificabile: true,
            hideif: {fieldexist: 'provaId',},
            inputType: 'singleDropdown',
            placeholder: 'Seleziona un Cliente',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'nominativo',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: false,
            },
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {
            modificabile: true,
            // hideif: {fieldexist: 'provaId',},
            disabledif: {fieldnotexist: 'cliente_id', fieldexist: 'padre'},
            nome: 'Sede',
            oggetti: ['sedeId'],
            inputType: 'singleDropdown',
            source: 'SediSource',
            internalOutput: 'sedeObject',
            OnFilter: 'filtroSede',
            OnChange: 'OnSedeChange',
            OutputField: 'sedeId',
            placeholder: 'Seleziona una sede',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'fullAddress',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: false,
            },
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {
            nome: 'Responsabile',
            source: '/anagrafica/persone/list',
            parameter: [{nome:"page", value: 1}, {nome:"size", value: 200}],
            responseHasData: true,
            oggetti: ['manager'],
            internalOutput: 'managerObject',
            OutputField: 'manager',
            OnChange: 'OnManagerChange',
            OnFilter: 'filtroManager',
            hideif: {fieldexist: 'padre'},
            modificabile: true,
            inputType: 'singleDropdown',
            placeholder: 'Seleziona un Responsabile',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'fullName',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: true,
            },
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {
            nome: 'Assegnatario  dell\'intervento',
            source: "PersoneSource",
            oggetti: ['manager'],
            internalOutput: 'managerObject',
            OutputField: 'manager',
            OnChange: 'OnManagerChange',
            hideif: {fieldnotexist: 'padre'},
            OnFilter: 'filtroManager',
            modificabile: true,
            inputType: 'singleDropdown',
            placeholder: 'Seleziona un Tecnico',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'fullName',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: true,
            },
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {
            modificabile: true,
            nome: 'Tipo',
            oggetti: ['tipo'],
            inputType: 'singleDropdown',
            source: 'difettilist',
            internalOutput: 'tipoObject',
            OutputField: 'tipo',
            placeholder: 'Seleziona',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput:true,
              idField: 'id',
              textField: 'label',
            },
            titleClass: 'control-label col-form-label'  ,
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {nome:'Data Segnalazione:', oggetti: ['data_inizio_prevista'], modificabile:true ,disabledif: {fieldexist: 'data_inizio_prevista'}, hideif:{fieldexist: 'padre'},inputType:'datetime-local', class: 'col-lg-3' },
          {nome:'Programmata per:', oggetti: ['data_inizio_prevista'], modificabile:true , hideif:{fieldnotexist: 'padre'}, inputType:'datetime-local', class: 'col-lg-3' },
          {nome:'Data Di Scadenza:', oggetti: ['data_scadenza_richiesta'], modificabile:true ,hideif:{fieldexist: 'padre'}, inputType:'datetime-local', class: 'col-lg-3' },
          {nome:'Data Inizio Effettiva:',hideif:{fieldnotexist: 'padre'}, oggetti: ['data_inizio_effettiva'], modificabile:true , inputType:'datetime-local', class: 'col-lg-3',prevDivClass: 'col-lg-3' },
          {nome:'Data Fine Effettiva:', hideif:{fieldnotexist: 'padre'}, oggetti: ['data_fine_effettiva'], modificabile:true , inputType:'datetime-local', class: 'col-lg-3' },
          {nome:"Referente Richiesta", oggetti: ['persona'], field:['nome'], modificabile:true , inputType:'text', type: 'object', class: 'col-lg-4', prevDivClass: "col-md-12",},
          {nome:"Numero di Telefono", oggetti: ['persona'], field:['telefono'], modificabile:true , inputType:'text', type: 'object', class: 'col-lg-4',},
          {nome:"Indirizzo Email", oggetti: ['persona'], field:['email'], modificabile:true , inputType:'text', type: 'object', class: 'col-lg-4'},
          {nome:'Luogo Partenza:', oggetti: ['partenza'], modificabile:true , inputType:'text', class: 'col-lg-4', prevDivClass: "col-md-12",},
          {nome:'Luogo Intervento:', oggetti: ['trasferta'], modificabile:true , inputType:'text', class: 'col-lg-4' },
          {nome:'Km Trasferta:', oggetti: ['km'], modificabile:true , inputType:'text', class: 'col-lg-4', },
          // {nome:'Includi Km:', oggetti: ['includereKm'], modificabile:true , inputType:'checkbox', type:'boolean', class: 'col-lg-2' },
          /*{nome:'Magazzino:', oggetti: ['magazzino'],hideif:{fieldexist: 'padre'}, modificabile:true , inputType:'checkbox', type:'boolean', class: 'col-lg-3', prevDivClass: 'col-12'},
          {nome:'Documenti:', oggetti: ['documenti'],hideif:{fieldexist: 'padre'}, modificabile:true , inputType:'checkbox', type:'boolean', class: 'col-lg-3'},
          {nome:'Data Appuntamento:', oggetti: ['dataappuntamento'],hideif:{fieldexist: 'padre'}, modificabile:true , inputType:'checkbox', type:'boolean', class: 'col-lg-3'},
          {nome:'Assegnabile:', oggetti: ['assegnabile'],hideif:{fieldexist: 'padre'}, modificabile:true , inputType:'checkbox', type:'boolean', class: 'col-lg-3'},
          */{nome:'Codice Richiesta Intervento:', oggetti: ['codice'], modificabile:true ,disabledif: {fieldexist: 'padre'}, inputType:'text', class: 'col-lg-4', prevDivClass: 'col-12' },
          {nome:'Codice Richiesta Gi.Emme.A:', oggetti: ['id'], modificabile:true , disabledif: {fieldexist: 'id',fieldnotexist: 'id'}, hideif:{ fieldexist: 'padre'}, inputType:'text', class: 'col-lg-4' },
          {nome:'Codice Richiesta Gi.Emme.A:', oggetti: ['padre'], modificabile:true , disabledif: {fieldexist: 'padre',fieldnotexist: 'padre'}, hideif:{ fieldnotexist: 'padre'}, inputType:'text', class: 'col-lg-4' },
          {nome:'Codice Chiusura Cliente:', oggetti: ['codiceChiusura'], modificabile:true , inputType:'text', class: 'col-lg-4'},
          {
            modificabile: true,
            nome: 'Categoria Operativa',
            oggetti: ['catOperativa'],
            inputType: 'singleDropdown',
            source: '/rma/rma/categorie',
            parameter: [],
            internalOutput: 'catOperativaObject',
            OutputField: 'catOperativa',
            placeholder: 'Seleziona',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput:true,
              idField: 'id',
              textField: 'label',
            },
            titleClass: 'control-label col-form-label'  ,
            class: 'col-lg-12',
            visibleifProhibited: true,
          },
          // {nome:'Ordine (Posizione nella Lista):', oggetti: ['ordine'], modificabile: true , inputType:'number', class: 'col-lg-3', prevDivClass: 'col-12' },
          {nome:'Descrizione del difetto:', oggetti: ['note'],  inputType: 'textarea', modificabile: true, class: 'col-lg-12'},
          {nome:'Attivita da eseguire:', hideif:{fieldexist: 'padre'}, oggetti: ['noteMateriali'], inputType: 'textarea', modificabile: true, class: 'col-lg-12'},
          {nome:'Descrizione sommaria delle opere eseguite:', hideif:{fieldnotexist: 'padre'}, oggetti: ['segnalazione'], inputType: 'textarea', modificabile: true, class: 'col-lg-12'},
          {nome:'Materiali di fornitura:', hideif:{fieldnotexist: 'padre'}, oggetti: ['noteMateriali'], inputType: 'textarea', modificabile: true, class: 'col-lg-12'},
          {nome:'Note Aggiuntive:', hideif:{fieldnotexist: 'padre'}, oggetti: ['noteTecnico'], inputType: 'textarea', modificabile: true, class: 'col-lg-12'},
          {nome:'Note Private:',  oggetti: ['notePrivate'], inputType: 'textarea', modificabile: true, class: 'col-lg-12'},

        ]
      }
    ],
    SezioniRmaEdit: [
      {
        sezione: '',
        campi: [
          {
            nome: 'Cliente',
            source: "AziendeSource",
            oggetti: ['cliente_id'],
            disabledif: {fieldexist: 'sedeObject'},
            internalOutput: 'clienteObject',
            OutputField: 'cliente_id',
            OnChange: 'OnClienteChange',
            modificabile: true,
            hideif: {fieldexist: 'provaId',},
            inputType: 'singleDropdown',
            placeholder: 'Seleziona un Cliente',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'nominativo',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: false,
            },
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {
            modificabile: true,
            // hideif: {fieldexist: 'provaId',},
            nome: 'Sede',
            disabledif: {fieldnotexist: 'cliente_id', fieldexist: 'padre', arrayFull: 'proveObject'},
            oggetti: ['sedeId'],
            inputType: 'singleDropdown',
            source: 'SediSource',
            internalOutput: 'sedeObject',
            OnFilter: 'filtroSede',
            OnChange: 'OnSedeChange',
            OutputField: 'sedeId',
            placeholder: 'Seleziona una sede',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'fullAddress',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: false,
            },
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {
            nome: 'Responsabile',
            source: '/anagrafica/persone/list',
            parameter: [{nome:"page", value: 1}, {nome:"size", value: 200}],
            responseHasData: true,
            oggetti: ['manager'],
            internalOutput: 'managerObject',
            OutputField: 'manager',
            OnChange: 'OnManagerChange',
            OnFilter: 'filtroManager',
            hideif: {fieldexist: 'padre'},
            modificabile: true,
            inputType: 'singleDropdown',
            placeholder: 'Seleziona un Responsabile',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'fullName',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: true,
            },
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {
            nome: 'Assegnatario  dell\'intervento',
            source: "PersoneSource",
            oggetti: ['manager'],
            internalOutput: 'managerObject',
            OutputField: 'manager',
            OnChange: 'OnManagerChange',
            hideif: {fieldnotexist: 'padre'},
            OnFilter: 'filtroManager',
            modificabile: true,
            inputType: 'singleDropdown',
            placeholder: 'Seleziona un Tecnico',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'fullName',
              searchPlaceholderText: "Cerca",
              allowSearchFilter: true,
              allowRemoteDataSearch: true,
            },
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {
            nome: 'Priorità',
            source: "PrioritaSource",
            oggetti: ['priorita'],
            internalOutput: 'prioritaObject',
            OutputField: 'priorita',
            modificabile: true,
            inputType: 'singleDropdown',
            hideif: {fieldexist: 'id'},//a quanto pare non lo mettiamo piu ma serve per non far scazzare il controllo priorita di fabio
            placeholder: 'Seleziona una Priorità',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput: true,
              idField: 'id',
              textField: 'label',
            },
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {
            modificabile: true,
            nome: 'Tipo',
            oggetti: ['tipo'],
            inputType: 'singleDropdown',
            source: '/rma/rma/types',
            internalOutput: 'tipoObject',
            OutputField: 'tipo',
            placeholder: 'Seleziona',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput:true,
              idField: 'id',
              textField: 'label',
              allowSearchFilter: true,
            },
            titleClass: 'control-label col-form-label'  ,
            class: 'col-lg-12',
            visibleifProhibited: true
          },
          {nome:'Data Segnalazione:', oggetti: ['data_inizio_prevista'], modificabile:true ,disabledif: {fieldexist: 'data_inizio_prevista'}, hideif:{fieldexist: 'padre'},inputType:'datetime-local', class: 'col-lg-3' },
          {nome:'Programmata per:', oggetti: ['data_inizio_prevista'], modificabile:true , hideif:{fieldnotexist: 'padre'}, inputType:'datetime-local', class: 'col-lg-3' },
          {nome:'Data Di Scadenza:', oggetti: ['data_scadenza_richiesta'], modificabile:true ,disabledif:{fieldexist: 'padre'}, inputType:'datetime-local', class: 'col-lg-3' },
          {nome:'Data Inizio Effettiva:',hideif:{fieldnotexist: 'padre'}, oggetti: ['data_inizio_effettiva'], modificabile:true , inputType:'datetime-local', class: 'col-lg-3' },
          {nome:'Data Fine Effettiva:', hideif:{fieldnotexist: 'padre'}, oggetti: ['data_fine_effettiva'], modificabile:true , inputType:'datetime-local', class: 'col-lg-3' },
          {nome:"Referente Richiesta", oggetti: ['persona'], field:['nome'], modificabile:true , inputType:'text', type: 'object', class: 'col-lg-4', prevDivClass: "col-md-12",},
          {nome:"Numero di Telefono", oggetti: ['persona'], field:['telefono'], modificabile:true , inputType:'text', type: 'object', class: 'col-lg-4',},
          {nome:"Indirizzo Email", oggetti: ['persona'], field:['email'], modificabile:true , inputType:'text', type: 'object', class: 'col-lg-4'},
          {nome:'Luogo Partenza:', oggetti: ['partenza'], modificabile:true , inputType:'text', class: 'col-lg-4', prevDivClass: "col-md-12",},
          {nome:'Luogo Intervento:', oggetti: ['trasferta'], modificabile:true , inputType:'text', class: 'col-lg-4' },
          {nome:'Km Trasferta:', oggetti: ['km'], modificabile:true , inputType:'text', class: 'col-lg-4', },
          // {nome:'Includi Km:', oggetti: ['includereKm'], modificabile:true , inputType:'checkbox', type:'boolean', class: 'col-lg-2' },
          {nome:'Magazzino:', oggetti: ['disponibile'], hideif:{fieldexist: 'padre'}, modificabile:true , inputType:'checkbox', type:'boolean', class: 'col-lg-3', prevDivClass: 'col-12'},
          {nome:'Documenti:', oggetti: ['documenti'], hideif:{fieldexist: 'padre'}, modificabile:true , inputType:'checkbox', type:'boolean', class: 'col-lg-3'},
          {nome:'Data Appuntamento:', oggetti: ['dataappuntamento'], hideif:{fieldexist: 'padre'}, modificabile:true , inputType:'checkbox', type:'boolean', class: 'col-lg-3'},
          {nome:'Assegnabile:', oggetti: ['assegnabile'], hideif:{fieldexist: 'padre'}, modificabile:true , inputType:'checkbox', type:'boolean', class: 'col-lg-3'},
          {nome:'Codice Richiesta Intervento:', oggetti: ['codice'], modificabile:true ,disabledif: {fieldexist: 'padre'}, inputType:'text', class: 'col-lg-4', prevDivClass: 'col-12' },
          {nome:'Codice Richiesta Gi.Emme.A:', oggetti: ['padre'], modificabile:true , disabledif: {fieldexist: 'id'}, hideif:{fieldnotexist: 'padre'}, inputType:'text', class: 'col-lg-4' },
          {nome:'Codice Richiesta Gi.Emme.A:', oggetti: ['id'], modificabile:true , disabledif: {fieldexist: 'id'}, hideif:{fieldnotexist: 'id', fieldexist: 'padre'}, inputType:'text', class: 'col-lg-4' },
          //{nome:'InterventoStatus:', oggetti: ['chiuso'], modificabile:true , inputType:'checkbox', class: 'col-lg-1'},
          {
            modificabile: true,
            nome: 'InterventoStatus',
            oggetti: ['chiuso'],
            inputType: 'singleDropdown',
            source: [{id:true,label: 'Chiuso'},{id:false,label: 'Non Chiuso'},{id:null,label: 'NA'}],
            internalOutput: 'chiusoObject',
            OutputField: 'chiuso',
            placeholder: 'Seleziona',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput:true,
              idField: 'id',
              textField: 'label',
            },
            titleClass: 'control-label col-form-label'  ,
            class: 'col-lg-12',
            visibleifProhibited: true,
          },
          {nome:'Codice Chiusura Cliente:', oggetti: ['codiceChiusura'], modificabile:true , disabledif:{ fieldnotexist:'chiuso'}, inputType:'text', class: 'col-lg-3'},
          // {nome:'Ordine (Posizione nella Lista):', oggetti: ['ordine'], modificabile: true , inputType:'number', class: 'col-lg-3', prevDivClass: 'col-12' },
          {
            modificabile: true,
            nome: 'Categoria Operativa',
            oggetti: ['catOperativa'],
            inputType: 'singleDropdown',
            source: '/rma/rma/categorie',
            parameter: [],
            internalOutput: 'catOperativaObject',
            OutputField: 'catOperativa',
            placeholder: 'Seleziona',
            settings: {
              singleSelection: true,
              closeDropDownOnSelection: true,
              singleOutput:true,
              idField: 'id',
              textField: 'label',
            },
            titleClass: 'control-label col-form-label'  ,
            class: 'col-lg-12',
            visibleifProhibited: true,
          },
          {nome:'Descrizione del difetto:', oggetti: ['note'],  inputType: 'textarea', modificabile: true, class: 'col-lg-12'},
          {nome:'Attivita da eseguire:', hideif:{fieldexist: 'padre'}, oggetti: ['noteMateriali'], inputType: 'textarea', modificabile: true, class: 'col-lg-12'},
          {nome:'Attivita da eseguire:', hideif:{fieldnotexist: 'padre'}, oggetti: ['padreObject'], field: ['noteMateriali'], inputType: 'textarea', modificabile: false, class: 'col-lg-12', titleStyle: {'font-size': 'medium', 'margin-right': '5px'}, titleClass: 'control-label col-form-label', style:{    'display': 'flex', 'justify-content': 'normal', 'padding-bottom': '20px', 'flex-direction': 'column'}, inputStyle: {},},
          {nome:'Descrizione sommaria delle opere eseguite:', hideif:{fieldnotexist: 'padre'}, oggetti: ['segnalazione'], inputType: 'textarea', modificabile: true, class: 'col-lg-12'},
          {nome:'Materiali di fornitura:', hideif:{fieldnotexist: 'padre'}, oggetti: ['noteMateriali'], inputType: 'textarea', modificabile: true, class: 'col-lg-12'},
          {nome:'Note Aggiuntive:', hideif:{fieldnotexist: 'padre'}, oggetti: ['noteTecnico'], inputType: 'textarea', modificabile: true, class: 'col-lg-12'},
          {nome:'Note Private:', oggetti: ['notePrivate'], inputType: 'textarea', modificabile: true, class: 'col-lg-12'},
          //TODO: rendere dinamica post
          {nome: 'Accessori Installati', hideif:{fieldnotexist: 'padre'}, oggetti: ['accessoriObject'], type:"table", header:[{nome: "Accessorio", oggetti: ['prodotto']},{nome: "Quantità", oggetti: ['quantita']}], modificabile: true, class: 'col-lg-12'},
          {nome:'_log_', hideif:{fieldnotexist: 'padre'}, oggetti: ['condizioni'], type:'checkboxArray', class: 'col-lg-12', filter: true, parameter: [{nome:"id", value: "sedeObject.clienteObject.id"}], sourceUrl:"", },
          {nome: "Partecipanti", hideif:{fieldnotexist: 'padre'},oggetti: ['partecipantiObject'], type: "Partecipanti", class: 'col-lg-12', modificabile:true, OnChange: 'OnPartecipantiChange',},
          {nome: "Files", type: "Files", url:"/rma/rma/file", class: 'col-lg-12', OnChange: 'OnFilesChange', modificabile: true}
        ]
      }
    ],
    CampiEsito: [
      {nome:'Data inserimento', oggetti: ['data_inizio_prevista'], viewInList:true, inputType: 'datetime-local', modificabile:true, class: 'col-lg-3'},
      {nome:'Data scadenza', oggetti: ['data_fine_prevista'], viewInList:true,  inputType: 'datetime-local', modificabile:true, class: 'col-lg-3'},
      {
        nome: 'Responsabile',
        viewInList:true,
        source: '/anagrafica/persone/list',
        parameter: [{nome:"page", value: 1}, {nome:"size", value: 200}],
        responseHasData: true,
        oggetti: ['manager'],
        internalOutput: 'managerObject',
        OutputField: 'manager',
        OnChange: 'OnManagerChange',
        OnFilter: 'filtroManager',
        modificabile: true,
        inputType: 'singleDropdown',
        placeholder: 'Seleziona un Responsabile',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'fullName',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: true,
        },
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Categoria task',
        oggetti: ['tipo'],
        inputType: 'singleDropdown',
        source: '/settings/get',
        parameter: [{nome:"id", value: 'segnalazione'},{nome:"type", value: 'segnalazione'}],
        internalOutput: 'tipoObject',
        OutputField: 'tipo',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'label',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: false,
        },
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {
        viewInList:true,
        modificabile: true,
        nome: 'Esito',
        oggetti: ['stato'],
        inputType: 'singleDropdown',
        source: 'Tipi',
        internalOutput: 'statoObject',
        OutputField: 'stato',
        placeholder: 'Seleziona',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'label',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: false,
        },
        class: 'col-lg-3',
        visibleifProhibited: true
      },
      {nome:'Chiuso:', oggetti: ['chiuso'], modificabile:true , inputType:'checkbox', class: 'col-lg-1'},
      {nome:'Oggetto task', oggetti: ['nome'], viewInList:true,  inputType: 'text', modificabile:true, class: 'col-lg-12'},
      {nome:'Descrizione task', oggetti: ['note'],  inputType: 'html', modificabile:true, class: 'col-lg-12'},

    ],
    FiltriProveAcquisto:[
      {nome:'Posizione', oggetti: ['posizione'], modificabile:true, class: 'col-lg-3', OnChange:"filter"},
      {nome: "Apprestamento", oggetti: ['prodotto'], modificabile:true, class: 'col-lg-3', OnChange:"filter"},
      {nome: "Marca", oggetti: ['marca'], modificabile:true, class: 'col-lg-3', OnChange:"filter"},
      {nome: "Ubicazione", oggetti: ['ubicazione'], modificabile:true, class: 'col-lg-3', OnChange:"filter"},
      {nome: "Note", oggetti: ['note'], modificabile:true, class: 'col-lg-3', OnChange:"filter"},
      {
        modificabile: true,
        nome: 'Ante',
        oggetti: ['ante'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-4',
        visibleifProhibited: true
      },
      //qrcode, prodotto, marca, anno,ante,posizione , dismesso
      {
        modificabile: true,
        nome: 'Matricola',
        oggetti: ['seriale'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-4',
        visibleifProhibited: true
      },
      {
        modificabile: true,
        nome: 'Tipo Apprestamento',
        oggetti: ['id_prodotto'],
        inputType: 'singleDropdown',
        source: 'ProdottiSource',
        internalOutput: 'prodottoObject',
        OutputField: 'id_prodotto',
        placeholder: 'Seleziona un prodotto',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'prodotto',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: false,
        },
        class: 'col-lg-4',
        visibleifProhibited: true
      },
      {
        nome: 'Sistema di comando',
        source: '/settings/get',
        parameter: [{nome:"id", value: 'comando'},{nome:"type", value: 'comando'}],
        responseHasData: false,
        oggetti: ['comando'],
        internalOutput: 'comandoObject',
        OutputField: 'comando',
        modificabile: true,
        inputType: 'singleDropdown',
        placeholder: 'Sistema di comando',
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput: true,
          idField: 'id',
          textField: 'label',
          searchPlaceholderText: "Cerca",
          allowSearchFilter: true,
          allowRemoteDataSearch: true,
        },
        class: 'col-lg-4',
        visibleifProhibited: true
      },
    ]
  },
  DashboardAddon:{
    giemmea:true,
  } ,
  Magazzino:{
    idProdotto:69,
    CampiLista:[
      {
        nome: 'Magazzini',
        oggetti: ['Lista'],
        type:"table",
        ExternalAddClick: 'OnAdd',
        header:[
          {nome: "Magazzino", oggetti: ['nome'], style:{'margin-left':'10px'}},
          /* {nome: "Targa", oggetti: ['targa'], style:{'margin-left':'10px'},hideif:{typeIsNot:['furgoni']}},
           {nome: "Modello", oggetti: ['modello'], style:{'margin-left':'10px'},hideif:{typeIsNot:['furgoni']}},
           {nome: "Marca", oggetti: ['marca'], style:{'margin-left':'10px'},},*/
        ],
        modificabile: true,
        class: 'col-lg-12',
        azioni:[
          {ExternalOnClick: 'OnEdit', icon: 'fa-pencil-alt', tooltip:'Edit', color: 'blue'},
          {ExternalOnClick: 'OnDelete', icon: 'fa-trash', tooltip:'Elimina', color: 'red'}
        ]
      },
    ],
    CampiEdit:[
      {
        modificabile: true,
        nome: 'Nome',
        oggetti: ['nome'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-6',
        visibleifProhibited: true,
        hideif:{typeIsNot:['magazzini']}
      },
      {
        modificabile: true,
        nome: 'Targa',
        oggetti: ['targa'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true,
        hideif:{typeIsNot:['furgoni']}
      },
      {
        modificabile: true,
        nome: 'Modello',
        oggetti: ['modello'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true,
        hideif:{typeIsNot:['furgoni']}
      },
      {
        modificabile: true,
        nome: 'Marca',
        oggetti: ['marca'],
        inputType: 'text',
        titleClass: 'control-label col-form-label',
        class: 'col-lg-3',
        visibleifProhibited: true,
        hideif:{typeIsNot:['furgoni']}
      },
      {
        modificabile: true,
        nome: 'Aggiungi Assegnatario',
        oggetti: ['addassegnazione'],
        inputType: 'singleDropdown',
        source: '/anagrafica/persone/list',
        parameter: [{nome:"page", value: 1}, {nome:"size", value: 200}],
        responseHasData: true,
        internalOutput: 'addassegnazioneObject',
        OnChange: "Assegna",
        placeholder: 'Seleziona',
        hideif:{typeIsNot:['furgoni'], fieldnotexist:'id'},
        settings: {
          singleSelection: true,
          closeDropDownOnSelection: true,
          singleOutput:true,
          idField: 'id',
          textField: 'fullName',
          allowSearchFilter: true,
        },
        titleClass: 'control-label col-form-label'  ,
        class: 'col-lg-12',
        visibleifProhibited: true
      },
      {
        nome: 'Storico Assegnazioni',
        oggetti: ['assegnazioni'],
        type:"table",
        hideif:{typeIsNot:['furgoni'], fieldnotexist:'id'},
        header:[
          {nome: "Evento", oggetti: ['label'], style:{'margin-left':'10px'},},
          {nome: "Data", oggetti: ['data'],   inputType: 'datetime-local',style:{'margin-left':'10px'},},
          {nome: "Tecnico", oggetti: ['tecnico'],style:{'margin-left':'10px'},},
        ],
        source:"/prodotti/furgoni/assegnazioni/list",
        parameter: [{nome:"page", value: 0}, {nome:"size", value: 200}, {nome: "id", parameter: "id" }],
        responseHasData: true,
        modificabile: true,
        class: 'col-lg-12',
        azioni:[
          {ExternalOnClick: 'OnSgancia', hideif:{fieldNotEqual:[{source:"tipo", value: "P"}], fieldnotexist: 'first'}, icon: 'fa-lock-open', tooltip:'Sgancia', color: 'blue'}
        ]
      },
      {
        source: "/prodotti/magazzini/movimentazioni/list",
        parameter: [{nome:"page", value: 0}, {nome:"size", value: 200}, {nome: "magazzino_id", parameter: "id" }],
        nome: 'Movimentazioni',
        oggetti: ['movimentazioni'],
        type:"table",
        hideif:{ fieldnotexist:'id'},
        header:[
          {nome: "Prodotto", oggetti: ['prodotto'], style:{'margin-left':'10px'},},
          {nome: "Data", oggetti: ['created_at'],   inputType: 'datetime-local',style:{'margin-left':'10px'},},
          {nome: "Descrizione", oggetti: ['descrizione'], style:{'margin-left':'10px'},},
          {nome: "Quantita", oggetti: ['qta'], style:{'margin-left':'10px'},},
        ],
        responseHasData: true,
        modificabile: true,
        class: 'col-lg-12',
      }
    ]
  },
  //#endregion
  //#region Menu
  Menu: [
    {
      title: "Menu",
      class: "has-arrow",
      label: "Menu",
      extralink: true
    },
    {
      module: "Dashboard",
      path: "/dashboard/dashboard",
      title: 'menu.dashboard',
      icon: "mdi mdi-gauge",
      capacita: ["menu-dashboard"]
    },
    {
      module: "Personale",
      path: "/listautenti/personale",
      title:'menu.PersonaleLabel',
      icon: "far fa-user",
      capacita: ["menu-persone"]
    },
    {
      module: "Clienti",
      path: "/listautenti/aziende/C",
      title:'menu.clienti',
      icon: "fas fa-address-book",
      capacita: ["menu-clienti"]
    },
    {
      module:"Progetti",
      path: "progetti/progetti",
      title: 'menu.progetti',
      icon: "mdi mdi-calendar-multiple-check",
      capacita: ["menu-progetti"]
    },
    {
      module: "Task",
      path: "task/unita",
      title: 'Calendario',
      icon: "mdi mdi-calendar",
    },
    {
      module: "Rma",
      path: "task/list/R/RA",
      title: 'Richieste di assistenza',
      icon: "mdi mdi-calendar",
    },
    {
      module: "Rma",
      path: "task/list/R/I",
      title: 'Interventi',
      icon: "mdi mdi-calendar",
    },
    {
      module: "Listini",
      path: "listino/listini",
      title: 'menu.listini',
      icon: "fas fa-bars",
      capacita: ["gestione-listino"],
    },
    {
      module: "Acquisti",
      path: "acquisti/acquisti",
      title: 'menu.acquisti',
      icon: "fas fa-cart-plus",
      capacita: ["menu-acquisti"],
    },
    {
      module: "Acquisti",
      path: "acquisti/groupedlavorazioni",
      title: 'menu.groupedlavorazioni',
      icon: "fab fa-opencart",
      capacita: ["menu-acquisti"],
    },
    {
      module: "Acquisti",
      path: "acquisti/lavorazioni",
      title: 'menu.lavorazioni',
      icon: "fab fa-opencart",
      capacita: ["menu-acquisti"],
    },
    {
      module: "Acquisti",
      path: "acquisti/spedizioni",
      title: 'menu.spedizioni',
      icon: "far fa-paper-plane",
      capacita: ["menu-spedizioni"],
    },
    {
      module: "Acquisti",
      path: "acquisti/container",
      title: 'menu.container',
      icon: "fas fa-truck-loading",
      capacita: ["menu-container"],
    },
    {
      module: "Acquisti",
      path: "acquisti/container/voci",
      title: 'menu.vocicontainer',
      icon: "fas fa-truck-moving",
      capacita: ["menu-container"],
    },
    {
      module: "Acquisti",
      path: "acquisti/scorte",
      title: 'menu.scorte',
      icon: "fas fa-calculator",
      capacita: ["menu-scorte"],
    },
    {
      module: "Interventi",
      title: "Attività",
      icon: "mdi mdi-wrench",
      class: "has-arrow",
      capacita: ["menu-fasi"],
      submenu: [
        {
          path: "interventi/interventi",
          title: 'menu.interventi',
          icon: "mdi mdi-wrench",
        },
        {
          path: "interventi/gantt",
          title: "Gantt",
          icon: "mdi mdi-chart-areaspline",
        }
      ]
    },
    {
      module: "Documenti",
      path: "progetti/documenti",
      title: 'menu.DocumentiLabel',
      icon: "mdi mdi-file-document",
      capacita: ["menu-documenti"]
    },
    // {
    //   module: "Prodotti",
    //   path: "progetti/prodotti",
    //   title: 'menu.ProdottiLabel',
    //   icon: "mdi mdi-barcode-scan",
    //   capacita: ["menu-prodotti"]
    // },
    {
      module: "Formazione",
      title: 'menu.FormazioneLabel',
      icon: "mdi mdi-school",//mdi-calendar-multiple-check //mdi-engine-outline
      class: "has-arrow",
      capacita: ["menu-servizi", "menu-formazione", "menu-calendar-servizi","menu-utenti-servizi"],
      submenu: [
        {
          path: "formazione/media",
          title: "menu.corsiMultimediali",
          icon: "mdi mdi-currency-eur",
          capacita: ["menu-formazione"]
        },
        {
          path: "formazione/corsi",
          title: "menu.corsi",
          icon: "mdi mdi-currency-eur",
          capacita: ["menu-calendar-servizi", "menu-servizi"]
        },
        {
          path: "/listautenti/personale/mod",
          title: "menu.docenti",
          icon: "mdi mdi-currency-eur",
          capacita: ["menu-utenti-servizi"]
        },
        {
          path: "/listautenti/personale/tut",
          title: "menu.tutor",
          icon: "mdi mdi-currency-eur",
          capacita: ["menu-utenti-servizi"]
        },
        {
          path: "/listautenti/personale/stu",
          title: "menu.studenti",
          icon: "mdi mdi-currency-eur",
          capacita: ["menu-utenti-servizi"]
        },
        {
          path: "formazione/materie",
          title: "menu.materie",
          icon: "mdi mdi-currency-eur",
          capacita: ["menu_calendar_tirocini"]
        },
        {
          path: "formazione/sedi",
          title: "menu.sedi",
          icon: "mdi mdi-currency-eur",
        }
      ]
    },
    {
      module: "Prima_Nota",
      title: "menu.Prima_NotaLabel",
      icon: "mdi mdi-cart",//mdi-calendar-multiple-check //mdi-engine-outline
      class: "has-arrow",
      capacita: ["menu-spese","menu-fatture"],
      submenu: [
        {
          path: "primanota/fatture",
          title: "menu.fattVendita",
          capacita: ["menu-fatture"]
        },
        {
          path: "/listautenti/aziende/f",
          title: "menu.fornitori",
          capacita: ["menu-fatture"]
        },
        {
          path: "primanota/primanota",
          title: "menu.primanota",
          capacita: ["menu-spese"]
        },
        {
          path: "primanota/lista-spese",
          title: "menu.listaspese",
          capacita: ["menu-spese"]
        }
      ]
    },
    {
      module: "Parti",
      path: "progetti/parti",
      title: "menu.PartiLabel",
      icon: "mdi mdi-barcode",
      capacita: ["menu-parti"]
    },
    {
      module: "Parti",
      path: "progetti/parti/categorie-list",
      title: "Categorie Parti",
      icon: "mdi mdi-cart",
      capacita: ["menu-parti"]
    },
    /* {
       module: "Materiali",
       path:"materiali/list/505",
       title: "Accessori",
       icon: "mdi mdi-cart",
       capacita: ["gestione-prodotti"]
     },*/
    {
      path:"progetti/codicisconto/69/lista",
      title: "Accessori",
      icon: "mdi mdi-cart",
      capacita: ["gestione-prodotti"]
    },
    {
      module: "Spedizioni",
      path: "spedizioni/lista",
      title: "menu.SpedizioniLabel",
      icon: "mdi mdi-airplane",
      capacita: ["menu-spedizioni"]
    },
    {
      module: "Stampe",
      path: "stampe/templates",
      title: "menu.StampeLabel",
      icon: "mdi mdi-printer",
      class: "has-arrow",
      capacita: ["menu-stampa"],
      submenu: [
        {
          path: "stampe/templates",
          title: "Templates",
          capacita: ["gestione-stampa"]
        },
        {
          path: "stampe/marker",
          title: "Marker",
          capacita: ["menu-stampa"]
        }
      ]
    },
    {
      module: "Settings",
      path: "settings/settings",
      title: "menu.SettingsLabel",
      icon: "mdi-settings",
      capacita: ["menu-settings"]
    },
    {
      module: "Admin",
      path: "listautenti/roles",
      title: "Ruoli",
      icon: "mdi mdi-lock-open-outline",
      capacita: ["menu-ruoli"]
    },
    {
      module: "Ticket",
      path: "ticket/list",
      title: "Tickets",
      icon: "mdi mdi-bookmark-outline",
      capacita: ["menu-ticket"]
    },
    {
      path: "magazzino/movimentazioni/magazzini/furgoni",
      title: "Movimentazioni",
      icon: "far fa-copy",
      capacita: ["menu-movimentazioni"]
    },
    {
      path: "magazzino/list/magazzini",
      title: "Magazzini",
      icon: "far fa-building",
      capacita: ["menu-magazzino"]
    },
    {
      path: "magazzino/list/furgoni",
      title: "Furgoni",
      icon: "fas fa-truck",
      capacita: ["menu-furgoni"]
    },
    // {
    //   notruoliOperativi: ["CA","AC"],
    //   module: "Ecommerce",
    //   title: 'menu.EcommerceLabel',
    //   icon: 'mdi mdi-cart',
    //   class: 'has-arrow',
    //   submenu: [
    //     {
    //       path: '/ecom/cat',
    //       title: 'Products',
    //       icon: 'mdi mdi-cards-variant',
    //       class: '',
    //       label: '',
    //       labelClass: '',
    //       extralink: false,
    //       submenu: []
    //     },
    //     {
    //       path: '/ecom/cart',
    //       title: 'Cart',
    //       icon: 'mdi mdi-cart',
    //       class: '',
    //       label: '',
    //       labelClass: '',
    //       extralink: false,
    //       submenu: []
    //     },
    //     {
    //       path: '/ecom/orders',
    //       title: 'Orders',
    //       icon: 'mdi mdi-chart-pie',
    //       class: '',
    //       label: '',
    //       labelClass: '',
    //       extralink: false,
    //       submenu: []
    //     }
    //   ]
    // },

    {
      ruoliOperativi:["AC","C","CA"],
      path: 'Cliente/profile',
      title: 'menu.profilo',
      icon: "far fa-user"
    }
  ],

  //#endregion
};


function Env(){
  var env = {...gmaenvironment}
  env = addModule(ItemsEnv(),env);
  env = addModule(movimentazioniEnv(), env);
  env = addModule(correzioniEnv(), env);
  return env

}

export const environment = Env()
